$(() => {
    $('#closeOldBrowserNotice').on('click', () => {
        $('#ielt10Notification').remove();
        $.cookie('old_browser_notice', true, { path: '/', expires: 365 });
    });
});
